"use client";

import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { useClaritySession } from "@/lib/auth/auth-store";
import { isDatadogRumConfigured } from "@/lib/observability/datadog-rum";

/**
 * Bridges the Zustand session store to Datadog RUM user context.
 * Must be mounted inside SessionInitializer so it receives session updates.
 * Renders nothing.
 */
export function DatadogSessionContext() {
  const session = useClaritySession();

  useEffect(() => {
    if (!isDatadogRumConfigured()) return;

    if (session.status === "authenticated") {
      datadogRum.setUser({
        id: session.claims["sub"] as string | undefined,
        email: session.claims["email"] as string | undefined,
        name: session.claims["name"] as string | undefined,
      });
      datadogRum.setGlobalContextProperty("tenant_ids", session.tenantIds);
      datadogRum.setGlobalContextProperty("roles", session.roles);
      datadogRum.setGlobalContextProperty("app", "ccof");
    } else if (session.status === "signed_out" || session.status === "error") {
      datadogRum.clearUser();
    }
  }, [session.status, session.claims, session.tenantIds, session.roles]);

  return null;
}
